import React, { memo, PropsWithChildren, } from 'react';

import MuiButton, { ButtonProps, } from '@material-ui/core/Button';

export default memo( function Button( _props:PropsWithChildren<any> ) {
	const {
		children,
		...props
	} = _props;

	const buttonProps: ButtonProps = props;

	return <MuiButton {...{
		...buttonProps,
	}}>
		{children}
	</MuiButton>;
} );
